import React, { useEffect } from 'react'
import anime from 'animejs'

import { ReactComponent as CharacterSvg } from '../../assets/svgs/character-bg.svg'

const BackgroundSVG = ({ shape, bgColor }) => {
    useEffect(() => {
        anime({
            targets: '.character-bg',
            rotate: 10,
            duration: 7500,
            direction: 'alternate',
            easing: 'easeInOutSine',
            loop: true
        })
    }, [])

    // NOTE: leaving this here in case we figure out how to get the raw SVG inserted into the DOM
    // This would let us target the points attribute and animate the shape
    // useEffect(() => {
    //     let svgEl = document.querySelector('#character-bg .polygon')
    //     let points = svgEl.getAttribute('points')
    //     console.log(points)
    // }, [])


    if (!shape) {
        return <CharacterSvg className={`character-bg ${bgColor}`} />
    }

    return (
        <img src={shape} alt="background shape" className="character-bg" />
    )
}

export default BackgroundSVG
